export interface RolePermissions {
    servers: number;
    domains: number;
    notifications: boolean;
    browser: boolean;
    monitoring: boolean;
    bots: boolean;
    anyRegion: boolean; // false = RU only
    support: boolean; // in-app support chat (Enterprise only)
}

export const ROLE_PERMISSIONS: Record<string, RolePermissions> = {
    starter: {
        servers: 3,
        domains: 5,
        notifications: false,
        browser: false,
        monitoring: false,
        bots: false,
        anyRegion: false,
        support: false,
    },
    pro: {
        servers: 10,
        domains: 25,
        notifications: true,
        browser: false,
        monitoring: true,
        bots: true,
        anyRegion: true,
        support: false,
    },
    enterprise: {
        servers: Infinity,
        domains: Infinity,
        notifications: true,
        browser: true,
        monitoring: true,
        bots: true,
        anyRegion: true,
        support: true,
    },
    admin: {
        servers: Infinity,
        domains: Infinity,
        notifications: true,
        browser: true,
        monitoring: true,
        bots: true,
        anyRegion: true,
        support: true,
    },
};

export const UPGRADE_MESSAGES = {
    notifications: 'Notifications require Pro or Enterprise plan',
    browser: 'Browser Check requires Enterprise plan',
    monitoring: 'Monitoring requires Pro or Enterprise plan',
    bots: 'Telegram Bots require Pro or Enterprise plan',
    anyRegion: 'Non-RU servers require Pro or Enterprise plan',
    support: 'In-app Support requires Enterprise plan',
    serverLimit: 'Server limit reached. Upgrade to add more.',
    domainLimit: 'Domain limit reached. Upgrade to add more.',
};

export type FeatureKey = keyof Omit<RolePermissions, 'servers' | 'domains'>;
